import { render, staticRenderFns } from "./UsersRightsManagement.vue?vue&type=template&id=a5808344&scoped=true&"
import script from "./UsersRightsManagement.vue?vue&type=script&lang=ts&"
export * from "./UsersRightsManagement.vue?vue&type=script&lang=ts&"
import style0 from "./UsersRightsManagement.vue?vue&type=style&index=0&id=a5808344&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5808344",
  null
  
)

export default component.exports